import { Directive, inject, input, TemplateRef } from '@angular/core';
import { ChatPanelMessage } from '@coin/chat-bot-util-types';

interface ChatPanelAssistantMessageContext<T> {
  $implicit: T;
}

/**
 * Marks the template that renders an assistant bubble's content instead of its plain text.
 * Bind the feature's messages so `let-message` is typed with the feature's message model.
 */
@Directive({
  selector: 'ng-template[coinChatPanelAssistantMessage]'
})
export class ChatPanelAssistantMessageDirective<T extends ChatPanelMessage> {
  readonly messages = input.required<T[]>({ alias: 'coinChatPanelAssistantMessage' });
  readonly template = inject<TemplateRef<ChatPanelAssistantMessageContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T extends ChatPanelMessage>(
    _directive: ChatPanelAssistantMessageDirective<T>,
    // Angular's context guard signature: the parameter exists only to be narrowed by the return type
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    context: unknown
  ): context is ChatPanelAssistantMessageContext<T> {
    return true;
  }
}
